import apiService from '@/services/apiService';

const actions = {
  getReasons({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/reason/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-recycle/reason/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/reason/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/reason', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/reason/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxel-recycle/reason/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
